import { useState } from 'react'
import { Home, LogOut, X, LogIn, PersonStanding } from 'lucide-react'
import { Link, useNavigate } from 'react-router-dom'
import { useOktaAuth } from '@okta/okta-react'
import { useUser } from '../Context/UserContext'

const Header = ({ appName = 'Care Service Supervisor' }) => {
  const [showConfirm, setShowConfirm] = useState(false)
  const navigate = useNavigate()
  const { oktaAuth } = useOktaAuth()
  const userInfo = useUser()
  const user = userInfo ? userInfo : null
  const handleConfirm = () => {
    setShowConfirm(false)
    onSignOut()
  }

  const onSignOut = async () => {
    setShowConfirm(false)
    try {
      await oktaAuth.signOut()
      navigate('/')
    } catch (error) {
      console.error('Sign out error:', error)
    }
  }

  const onSignIn = async () => {
    try {
      await oktaAuth.signInWithRedirect()
    } catch (error) {
      console.error('Login error:', error)
      navigate('/no-access?reason=login-failed')
    }
  }

  return (
    <>
      <header className='bg-white border-b border-gray-100 shadow-sm z-10 flex-shrink-0'>
        <div className='px-4 sm:px-6 lg:px-8 container mx-auto'>
          <div className='flex flex-col sm:flex-row items-center justify-between py-4 sm:h-16'>
            <div className='flex items-center justify-between w-full sm:w-auto'>
              <div className='flex items-center space-x-3'>
                <h1
                  className='text-lg sm:text-xl font-bold text-gray-900 cursor-pointer hover:text-indigo-600 transition-colors duration-200'
                  onClick={() => {
                    navigate('/')
                    window.location.reload()
                  }}
                >
                  {appName}
                </h1>
              </div>
              <nav className='flex space-x-4 sm:space-x-6 sm:ml-8'>
                <Link
                  to='/'
                  className='flex items-center space-x-2 text-indigo-600 font-medium hover:text-indigo-700 transition-colors duration-200'
                >
                  <Home className='w-4 h-4' />
                  <span className='text-sm sm:text-base'>Home</span>
                </Link>
              </nav>

               <nav className='flex space-x-4 sm:space-x-6 sm:ml-8'>
                <Link
                  to='/ai-assistant'
                  className='flex items-center space-x-2 text-indigo-600 font-medium hover:text-indigo-700 transition-colors duration-200'
                >
                  <PersonStanding className='w-4 h-4' />
                  <span className='text-sm sm:text-base'>Caregivers</span>
                </Link>
              </nav>
              
            </div>

            <div className='flex items-center space-x-4 mt-4 sm:mt-0'>
              {user ? (
                <>
                  <span className='hidden sm:inline text-sm text-gray-600'>
                    Hello, {user?.name || 'User'}
                  </span>
                  <button
                    onClick={() => setShowConfirm(true)}
                    className='flex items-center space-x-2 px-3 py-1.5 text-sm text-white bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg shadow-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500'
                    aria-label='Sign out of the application'
                  >
                    <LogOut className='w-4 h-4' />
                    <span>Sign Out</span>
                  </button>
                </>
              ) : (
                <button
                  onClick={onSignIn}
                  className='flex items-center space-x-2 px-3 py-1.5 text-sm text-white bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg shadow-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500'
                  aria-label='Sign in to the application'
                >
                  <LogIn className='w-4 h-4' />
                  <span>Sign In</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </header>

      {showConfirm && (
        <div className='fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-50 px-4'>
          <div className='bg-white rounded-2xl shadow-xl max-w-md w-full p-6 sm:p-8 transform transition-all duration-300 scale-100'>
            <div className='flex justify-between items-center mb-6'>
              <h2 className='text-lg font-semibold text-gray-900'>
                Confirm Sign Out
              </h2>
              <button
                onClick={() => setShowConfirm(false)}
                className='text-gray-500 hover:text-gray-700 transition-colors duration-200'
                aria-label='Close sign out confirmation'
              >
                <X className='w-5 h-5' />
              </button>
            </div>

            <p className='text-sm text-gray-600 mb-6'>
              Are you sure you want to sign out?
            </p>

            <div className='flex justify-end space-x-3'>
              <button
                onClick={() => setShowConfirm(false)}
                className='px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-200 rounded-lg hover:bg-gray-200 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-500'
                aria-label='Cancel sign out'
              >
                Cancel
              </button>
              <button
                onClick={handleConfirm}
                className='flex items-center space-x-2 px-3 py-1.5 text-sm text-white bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg shadow-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500'
                aria-label='Confirm sign out'
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Header
